import PropTypes from "prop-types";

export default PropTypes.shape({
  unreadMessagesCount: PropTypes.number.isRequired,
  mobileMenuLinks: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      url: PropTypes.string,
      subNav: PropTypes.boolean,
      notificationDot: PropTypes.boolean,
    })
  ).isRequired,
  homepageUrl: PropTypes.string.isRequired,
  messagesUrl: PropTypes.string.isRequired,
  isEmployer: PropTypes.bool.isRequired,
  candidatesSubNav: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      url: PropTypes.string,
    })
  ).isRequired,
});
